import { AxiosResponse } from "axios";
import { getAxiosInstance } from "./api-utils";

export type ResourceStats = {
    resourceCode: string;
    count: number;
};

export type DashboardStats = {
    totalWorksites: number;
    totalCustomers: number;
    totalOrders: number;
    ordersByStatus: Record<string, number>;
    completedPerResource: ResourceStats[];
};

const DASHBOARD = "/dashboard";

export async function getDashboardStats(): Promise<DashboardStats> {
    const response: AxiosResponse<DashboardStats> = await getAxiosInstance().get(DASHBOARD);
    return response.data;
}
